import { render, staticRenderFns } from "./my-business-notes.vue?vue&type=template&id=30dbd800&scoped=true"
import script from "./my-business-notes.vue?vue&type=script&lang=js"
export * from "./my-business-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dbd800",
  null
  
)

export default component.exports